import "core-js/modules/es6.regexp.split";
import Cookies from "js-cookie";
export var TokenKey = "Authorization";
export var appId = "appId";
export var avatar = "avatar";
export var personName = "personName";
var isIpAddress = function isIpAddress() {
  // 返回true，表示存在正常一级域名，否则是ip地址或者localhost
  var hostname = document.location.hostname;
  var flag = false;
  if (hostname === "localhost") {
    // 如果不是正式环境token都存到当前自己的域名下
    flag = false;
  } else {
    for (var i in hostname) {
      var asc = hostname.charCodeAt(i);
      if (asc >= 65 && asc <= 90 || asc >= 97 && asc <= 122) {
        flag = true;
        break;
      }
    }
  }
  return flag;
};
console.log("store", isIpAddress());
var digits = process.env.NODE_ENV !== "production" ? 3 : 2;
var voDomain = document.domain.split(".").slice(-digits).join(".");
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  if (isIpAddress()) {
    console.log(voDomain, "domain");
    return Cookies.set(TokenKey, token, {
      // expires: -1,
      path: "/",
      domain: ".".concat(voDomain)
    });
  } else {
    return Cookies.set(TokenKey, token);
  }
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function removeTokenTwo() {
  if (isIpAddress()) {
    return Cookies.set(TokenKey, null, {
      expires: -1,
      path: "/",
      domain: ".".concat(voDomain)
    });
  }
}
export function getAppId() {
  return Cookies.get(appId);
}
export function setAppId(id) {
  return Cookies.set(appId, id);
}
export function removeAppId() {
  return Cookies.remove(appId);
}
export function getAvatar() {
  return Cookies.get(avatar);
}
export function setAvatar(id) {
  if (isIpAddress()) {
    return Cookies.set(avatar, id, {
      // expires: -1,
      path: "/",
      domain: ".".concat(voDomain)
    });
  } else {
    return Cookies.set(avatar, id);
  }
}
export function removeAvatar() {
  if (isIpAddress()) {
    return Cookies.set(avatar, null, {
      expires: -1,
      path: "/",
      domain: ".".concat(voDomain)
    });
  } else {
    return Cookies.remove(avatar);
  }
}
export function getPersonName() {
  return Cookies.get(personName);
}
export function setPersonName(id) {
  if (isIpAddress()) {
    return Cookies.set(personName, id, {
      // expires: -1,
      path: "/",
      domain: ".".concat(voDomain)
    });
  } else {
    return Cookies.set(personName, id);
  }
}
export function removePersonName() {
  if (isIpAddress()) {
    return Cookies.set(personName, null, {
      expires: -1,
      path: "/",
      domain: ".".concat(voDomain)
    });
  } else {
    return Cookies.remove(personName);
  }
}
export function _postMessage() {
  if (self !== top) {
    window.parent.postMessage({
      data: "developPricing"
    }, "http://haoyuwms.cn/wms");
  }
}